import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Battery.scss';

const propTypes = {
    animate: PropTypes.bool,
};

const defaultProps = {
    animate: false,
};

const Battery = ({ animate, ...props }) => {
    const classes = classNames({
        Battery: true,
        animate,
    });
    return <div className={classes} style={{ backgroundImage: `url('${window.HELIOS.publicPath}images/icon-battery-2x.png')` }} {...props} />;
};

Battery.propTypes = propTypes;
Battery.defaultProps = defaultProps;

export default Battery;
